import { Link } from "react-router-dom";

const ACTION_CLASS =
  "inline-flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50";

export function HseRowActions({ children, className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center justify-end gap-2 ${className}`}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </div>
  );
}

export function HseRowActionLink({ to, icon: Icon, children, title }) {
  return (
    <Link to={to} title={title} className={ACTION_CLASS}>
      {Icon ? <Icon className="h-4 w-4" /> : null}
      {children}
    </Link>
  );
}

export function HseRowActionButton({ onClick, icon: Icon, children, title, disabled = false }) {
  return (
    <button type="button" title={title} disabled={disabled} onClick={onClick} className={ACTION_CLASS}>
      {Icon ? <Icon className="h-4 w-4" /> : null}
      {children}
    </button>
  );
}
